import React, { useEffect, useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import PromotionProducts from './PromotionProducts/PromotionProducts';
import PromotionTerms from './PromotionTerms/PromotionTerms';
import PromotionOrders from './PromotionOrders/PromotionOrders';
import ManageTraders from './ManageTraders/ManageTraders';
import TraderRegistration from './TraderRegistration/TraderRegistration';
import RooferRegistration from './RooferRegistration/RooferRegistration';
import TermsAcceptation from './TermsAcceptation/TermsAcceptation';
import PromotionRegulations from './PromotionRegulations/PromotionRegulations';
import LinkItem from 'components/LinkItem';
import { useMediaQuery } from 'react-responsive';
import { LG, MD, USER_ROLE_MASTER, USER_ROLE_ROOFER, USER_ROLE_TRADER } from 'lib/util';
import { useUser } from 'reducers';
import { FaAngleDown, FaAngleRight } from 'react-icons/fa';

const Promotions = () => {
    const location = useLocation();
    const isDesktop = useMediaQuery({ minWidth: MD });
    const isLarge = useMediaQuery({ minWidth: LG });
    const user = useUser();
    const [activeKey, setActiveKey] = useState('accept-terms');
    const history = useHistory();
    const areRulesAccepted = user?.promotionTermsAccept !== '19010101' && user?.promotionalProgramEnroll !== '19010101';

    const [showUsersDropdown, setShowUsersDropdown] = useState(false);
    const [showTermsDropdown, setShowTermsDropdown] = useState(false);

    const notRestrictedPaths = [
        `${process.env.PUBLIC_URL}/promotions/accept-terms`,
        `${process.env.PUBLIC_URL}/promotions/promotion-regulations`
    ];

    useEffect(() => {
        if (!notRestrictedPaths.includes(location.pathname) && !areRulesAccepted) {
            history.replace(`${process.env.PUBLIC_URL}/promotions/accept-terms`);
        } else if (location.pathname === `${process.env.PUBLIC_URL}/promotions`) {
            history.replace(`${process.env.PUBLIC_URL}/promotions/articles`);
        }

        if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/terms`)) {
            setActiveKey('terms');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/orders`)) {
            setActiveKey('orders');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/register-roofer`)) {
            setActiveKey('register-roofer');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/register-trader`)) {
            setActiveKey('register-trader');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/manage-traders`)) {
            setActiveKey('manage-traders');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/articles`)) {
            setActiveKey('articles');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/promotion-regulations`)) {
            setActiveKey('promotion-regulations');
        } else if (location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/accept-terms`)) {
            setActiveKey('accept-terms');
        }

        if (areRulesAccepted && activeKey === 'accept-terms' && location.pathname.includes(`${process.env.PUBLIC_URL}/promotions/accept-terms`)) {
            setActiveKey('articles');
        }
    }, [location.pathname]);

    return (
        <>
            {isDesktop && (
                <Navbar className='sub-navbar' expand='lg'>
                    {user?.promotionTermsAccept !== '19010101' && user?.promotionalProgramEnroll !== '19010101' ? (
                        <Nav
                            justify
                            variant='pills'
                            className='flex-grow-1 flex-shrink-1'
                            activeKey={activeKey}
                        >
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/articles`} eventKey='articles'>Artykuły promocyjne</LinkItem>
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/orders`} eventKey='orders'>Zamówienia na artykuły promocyjne</LinkItem>
                            {[USER_ROLE_TRADER, USER_ROLE_MASTER].includes(user?.role ?? '') &&
                                <NavDropdown
                                    renderMenuOnMount
                                    title={<div className='promotion-submenu-dropdown-title'>Użytkownicy <div className='angle'>{showUsersDropdown ? <FaAngleDown /> : <FaAngleRight />}</div></div>}
                                    id='promotion-users-dropdown'
                                    className={`promotion-submenu-dropdown ${!isLarge ? 'submenu-dropdown-medium' : ''}`}
                                    show={showUsersDropdown}
                                    onMouseEnter={isLarge ? () => setShowUsersDropdown(true) : () => {}}
                                    onMouseLeave={isLarge ? () => setShowUsersDropdown(false) : () => {}}
                                    onClick={isLarge ? () => setShowUsersDropdown(false) : () => { setShowUsersDropdown(!showUsersDropdown); }}
                                >
                                    {user?.role !== USER_ROLE_ROOFER &&
                                        <NavDropdown.Item
                                            eventKey='register-roofer'
                                            className={location.pathname === `${process.env.PUBLIC_URL}/promotions/register-roofer` ? 'promotions-submenu-active' : ''}
                                            as={Link}
                                            to={`${process.env.PUBLIC_URL}/promotions/register-roofer`}
                                        >
                                            Rejestruj dekarza
                                        </NavDropdown.Item>}
                                    {user?.role === USER_ROLE_MASTER &&
                                        <NavDropdown.Item
                                            eventKey='register-trader'
                                            className={location.pathname === `${process.env.PUBLIC_URL}/promotions/register-trader` ? 'promotions-submenu-active' : ''}
                                            as={Link}
                                            to={`${process.env.PUBLIC_URL}/promotions/register-trader`}
                                        >
                                            Rejestruj handlowca
                                        </NavDropdown.Item>}
                                    {user?.role === USER_ROLE_MASTER &&
                                        <NavDropdown.Item
                                            eventKey='manage-traders'
                                            className={location.pathname === `${process.env.PUBLIC_URL}/promotions/register-trader` ? 'promotions-submenu-active' : ''}
                                            as={Link}
                                            to={`${process.env.PUBLIC_URL}/promotions/manage-traders`}
                                        >
                                            Administracja handlowcami
                                        </NavDropdown.Item>}
                                </NavDropdown>}
                            <NavDropdown
                                renderMenuOnMount
                                title={<div className='promotion-submenu-dropdown-title'>Jak to działa? <div className='angle'>{showTermsDropdown ? <FaAngleDown /> : <FaAngleRight />}</div></div>}
                                id='promotion-users-dropdown'
                                className={`promotion-submenu-dropdown ${!isLarge ? 'submenu-dropdown-medium' : ''}`}
                                show={showTermsDropdown}
                                onMouseEnter={isLarge ? () => setShowTermsDropdown(true) : () => {}}
                                onMouseLeave={isLarge ? () => setShowTermsDropdown(false) : () => {}}
                                onClick={isLarge ? () => setShowTermsDropdown(false) : () => { setShowTermsDropdown(!showTermsDropdown); }}
                            >
                                <NavDropdown.Item
                                    eventKey='terms'
                                    className={location.pathname === `${process.env.PUBLIC_URL}/promotions/terms` ? 'promotions-submenu-active' : ''}
                                    as={Link}
                                    to={`${process.env.PUBLIC_URL}/promotions/terms`}
                                >
                                    Regulamin
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    eventKey='promotion-regulations'
                                    className={location.pathname === `${process.env.PUBLIC_URL}/promotions/promotion-regulations` ? 'promotions-submenu-active' : ''}
                                    as={Link}
                                    to={`${process.env.PUBLIC_URL}/promotions/promotion-regulations`}
                                >
                                    Zasady działania programu promocyjnego
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    ) : (
                        <Nav
                            justify
                            variant='pills'
                            className='flex-grow-1 flex-shrink-1'
                            activeKey={activeKey}
                        >
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/accept-terms`} eventKey='accept-terms'>Akceptacja Regulaminu</LinkItem>
                            <LinkItem to={`${process.env.PUBLIC_URL}/promotions/promotion-regulations`} eventKey='promotion-regulations'>Zasady działania programu promocyjnego</LinkItem>
                        </Nav>
                    )}
                </Navbar>
            )}
            <Switch>
                <Route path={`${process.env.PUBLIC_URL}/promotions/articles`}>
                    <PromotionProducts />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/promotions/terms`}>
                    <PromotionTerms />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/promotions/accept-terms`}>
                    <TermsAcceptation />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/promotions/promotion-regulations`}>
                    <PromotionRegulations />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/promotions/orders/:page`}>
                    <PromotionOrders />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/promotions/orders`}>
                    <PromotionOrders />
                </Route>
                {(user?.role === USER_ROLE_MASTER || user?.role === USER_ROLE_TRADER) &&
                    <Route path={`${process.env.PUBLIC_URL}/promotions/register-roofer`}>
                        <RooferRegistration />
                    </Route>}
                {user?.role === USER_ROLE_MASTER &&
                    <Route path={`${process.env.PUBLIC_URL}/promotions/register-trader`}>
                        <TraderRegistration />
                    </Route>}
                {user?.role === USER_ROLE_MASTER &&
                    <Route path={`${process.env.PUBLIC_URL}/promotions/manage-traders`}>
                        <ManageTraders />
                    </Route>}
                {areRulesAccepted ?
                    <Route>
                        <PromotionProducts />
                    </Route> :
                    <Route>
                        <TermsAcceptation />
                    </Route>}
            </Switch>
        </>
    );
};

export default Promotions;
